<script>
import { Doughnut } from 'vue-chartjs';

export default {
  name: 'DoughnutOccupation',
  extends: Doughnut,
  props: {
    usedPercentual: {
      default: 0
    }
  },
  watch: {
    usedPercentual (usedPercentual) {
      this.drawChart(usedPercentual);
    }
  },
  methods: {
    drawChart (usedPercentual) {
      const restSum = 100 - usedPercentual;
      this.renderChart({
        datasets: [
          {
            backgroundColor: ['#1c84c6', '#888888'],
            data: [usedPercentual, restSum]
          }
        ]
      })
    }
  }
}
</script>
